'use strict';

import angular from 'angular';
import ProtectedController from './protected.controller';

export default angular.module('conduuApp.protected', [])
  .controller('ProtectedController', ProtectedController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/protected/index.js